import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../config";
import {
FaEnvelope,
FaLock,
FaUser,
FaEye,
FaEyeSlash,
} from "react-icons/fa";
import axios from "axios";
import "./Register.css";

export default function Register() {
const navigate = useNavigate();
const [nom, setNom] = useState("");
const [email, setEmail] = useState("");
const [motDePasse, setMotDePasse] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
const [loading, setLoading] = useState(false);
const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

const handleRegister = async (e) => {
e.preventDefault();
if (motDePasse !== confirmPassword) {
  alert("⚠️ Les mots de passe ne correspondent pas !");
  return;
}

try {
  setLoading(true);
  const payload = {
    nom,
    email,
    mot_de_passe: motDePasse,
  };

  const res = await axios.post(`${API_URL}/api/entreprise/register`, payload);

  alert(res.data.message || "Inscription réussie");
  navigate("/login");
} catch (error) {
  console.error("Erreur inscription :", error);
  if (error.response?.data?.message) {
    alert(error.response.data.message);
  } else {
    alert("❌ Erreur serveur, réessayez plus tard");
  }
} finally {
  setLoading(false);
}


};

return (
<div
className="register-container"
style={{
minHeight: "100vh",
display: "flex",
justifyContent: "center",
alignItems: "center",
backgroundColor: "#f5f5f5",
padding: "20px",
}}
>
<div
className="register-card"
role="region"
aria-label="Inscription"
style={{
width: "100%",
maxWidth: "400px",
background: "white",
borderRadius: "10px",
boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
padding: "30px 25px",
}}
>
<header className="card-header" style={{ textAlign: "center" }}>
<h1 className="register-title" style={{ marginBottom: "5px" }}>
Créer un compte </h1>
<p className="register-subtitle" style={{ color: "#555" }}>
Inscrivez votre entreprise pour accéder à votre espace </p> </header>


    <div className="card-body" style={{ marginTop: "25px" }}>
      <form onSubmit={handleRegister} className="register-form">
        <div className="input-group">
          <FaUser className="icon" />
          <input
            type="text"
            placeholder="Nom complet / Entreprise"
            value={nom}
            onChange={(e) => setNom(e.target.value)}
            required
            aria-label="Nom complet ou entreprise"
          />
        </div>

        <div className="input-group">
          <FaEnvelope className="icon" />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            aria-label="Email"
          />
        </div>

        <div className="input-group password-group">
          <FaLock className="icon" />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Mot de passe"
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
            required
            aria-label="Mot de passe"
          />
          <span
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <div className="input-group password-group">
          <FaLock className="icon" />
          <input
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirmer le mot de passe"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            aria-label="Confirmer le mot de passe"
          />
          <span
            className="toggle-password"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "15px",
          }}
        >
          <button type="submit" className="btn-register" disabled={loading}>
            {loading ? "Inscription..." : "S’inscrire"}
          </button>
        </div>
      </form>

      <p
        className="login-link"
        style={{
          textAlign: "center",
          marginTop: "20px",
          color: "#555",
        }}
      >
        Déjà un compte ?{" "}
        <span
          onClick={() => navigate("/login")}
          style={{ color: "#007bff", cursor: "pointer" }}
        >
          Connexion
        </span>
      </p>
    </div>
  </div>
</div>


);
}
